export const RESET_PASSWORD_ACTION = 'authPages/RESET_PASSWORD';
